// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"428027cc","2800":"53022d30","6909":"33f26683"}[chunkId] + ".chunk.css";
};